module.exports = __webpack_public_path__ + "img/Knowit_logo.e4aecacd.png";